var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2527 7.02694C19.3405 6.0421 18.0665 5.49976 16.6602 5.49976C15.2465 5.49976 13.9682 6.03882 13.0602 7.01757C12.1424 8.0071 11.6952 9.35194 11.8002 10.8041C12.0083 13.6691 14.1885 15.9998 16.6602 15.9998C19.1319 15.9998 21.3083 13.6696 21.5197 10.8051C21.6261 9.36601 21.1761 8.02397 20.2527 7.02694Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9104 26.4999H8.41042C8.19445 26.5027 7.98057 26.4573 7.78434 26.3671C7.58812 26.2768 7.41447 26.144 7.27605 25.9782C6.97136 25.6139 6.84855 25.1166 6.93949 24.6136C7.33511 22.4189 8.5698 20.5753 10.5104 19.2811C12.2345 18.1322 14.4184 17.4999 16.6604 17.4999C18.9025 17.4999 21.0864 18.1327 22.8104 19.2811C24.751 20.5749 25.9857 22.4185 26.3814 24.6132C26.4723 25.1161 26.3495 25.6135 26.0448 25.9777C25.9064 26.1436 25.7328 26.2765 25.5366 26.3669C25.3403 26.4572 25.1264 26.5026 24.9104 26.4999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolo);
export default __webpack_public_path__ + "static/media/Solo.7609bc0ca41d2f9cb6d45982b2c4f70a.svg";
export { ForwardRef as ReactComponent };